import { render, staticRenderFns } from "./Traincourse.vue?vue&type=template&id=7d5abdcf&scoped=true&"
import script from "./Traincourse.vue?vue&type=script&lang=js&"
export * from "./Traincourse.vue?vue&type=script&lang=js&"
import style0 from "./Traincourse.vue?vue&type=style&index=0&id=7d5abdcf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5abdcf",
  null
  
)

export default component.exports